module.exports = __webpack_public_path__ + "static/img/5.aa5afe57.jpeg";